module.exports = __webpack_public_path__ + "static/media/store.71fceb43.png";